const isDev = process.env.NODE_ENV === 'development';

export const API_BASE_URL = isDev
  ? (process.env.REACT_APP_API_URL || 'http://localhost:8000')
  : '';

export const WS_BASE_URL = isDev
  ? (process.env.REACT_APP_WS_URL || 'ws://localhost:8000')
  : `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}`;
